(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7571],{

/***/ 17011:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-watch/video-streaming/google-chromecast",
      function () {
        return __webpack_require__(23271);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56168);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62044);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63861);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46323);
/* harmony import */ var enums_namespaces__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99731);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52662);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17651);
/* harmony import */ var next_translate_Trans__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46834);

// @ts-ignore










var Samsung = function(param) {
    var countryCode = param.countryCode;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(enums_namespaces__WEBPACK_IMPORTED_MODULE_4__/* .Namespace.VideoStreaming */ .l.VideoStreaming).t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
                children: (0,helpers__WEBPACK_IMPORTED_MODULE_8__/* .basicSEO */ .Fi)(t("seo:how_to_watch_streaming_chromecast_title"), t("seo:how_to_watch_streaming_chromecast_description"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: [
                    (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().container)
                ].join(" "),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: t("chromecast_title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().desc),
                        dangerouslySetInnerHTML: {
                            __html: t("chromecast_description")
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: t("chromecast_instalation")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: t("chromecast_step_1")
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: t("chromecast_step_2")
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: t("chromecast_step_3")
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            i18nKey: "video-streaming:chromecast_step_4",
                                            components: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().settings)
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_5___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().img), (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default()["step-4"]))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_Trans__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        i18nKey: "video-streaming:chromecast_step_5",
                                        components: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_10___default().chromecast)
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: t("chromecast_step_6")
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,context__WEBPACK_IMPORTED_MODULE_6__/* .withForcePlanToLoggedInUnsubs */ .DE)(Samsung));


/***/ }),

/***/ 63861:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"google-chromecast_container__xnO1b","settings":"google-chromecast_settings__OWLQ1","chromecast":"google-chromecast_chromecast__zn6IT","desc":"google-chromecast_desc__QfdNi","img":"google-chromecast_img__2GVxW","step-4":"google-chromecast_step-4__V2E7y"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(17011); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);